import { type IResource } from '@landsbankinn/l16n';
import { type InputValidationState } from '@landsbankinn/ui-kit';
import { useCallback, useReducer, useState } from 'react';
import {
  useApplicationServerContext,
  type LoginServerState,
} from 'src/state/server';
import { isCorporateKennitala, isKennitala } from '../../utils';
import { res } from './AudkenniApp.res';

export function useAudkenniAppValidation() {
  const [serverState] = useApplicationServerContext() as [LoginServerState];

  // const [{ form }, formDispatch] = useApplicationClientContext();
  const [invalidResource, setInvalidResource] = useState<IResource>(
    res.validationKennitalaInvalid,
  );
  type State = {
    kennitala: {
      value: string;
      validationState?: InputValidationState;
    };
    xsrf: string;
  };
  type Action =
    | {
        type: 'on change kennitala';
        value: string;
        validationState: InputValidationState;
      }
    | {
        type: 'on xsrf token';
        value: string;
      };

  const [state, dispatch] = useReducer(
    function formReducer(formState: State, action: Action): State {
      switch (action.type) {
        case 'on change kennitala': {
          return {
            ...formState,
            kennitala: {
              value: action.value,
              validationState: action.validationState,
            },
          };
        }
        case 'on xsrf token': {
          return {
            ...formState,
            xsrf: action.value,
          };
        }
        default:
          return formState;
      }
    },
    {
      kennitala: {
        value: '',
        validationState: 'unset',
      },
      xsrf: serverState.forms.audkenniApp.fields.xsrf.value || '',
    },
  );
  const validate = useCallback(function validate(
    kennitala?: string | undefined,
  ): InputValidationState {
    if (kennitala !== undefined && kennitala !== '') {
      if (isKennitala(kennitala)) {
        return 'valid';
      } else if (isCorporateKennitala(kennitala)) {
        setInvalidResource(res.validationUnableToUseCorporateKennitala);
        return 'invalid';
      } else {
        setInvalidResource(res.validationKennitalaInvalid);
        return 'invalid';
      }
    } else {
      return 'unset';
    }
  }, []);
  const onKennitalaChanged = useCallback(
    function onKennitalaChanged(kennitala: string) {
      const newValue = kennitala.replace('-', '').replace(' ', '');
      const validationState = validate(newValue);
      // dispatch for the actual input
      dispatch({
        type: 'on change kennitala',
        value: newValue,
        validationState: validationState,
      });
    },
    [validate],
  );

  const onXsrf = useCallback(function onXsrfChanged(xsrf: string) {
    dispatch({ type: 'on xsrf token', value: xsrf });
  }, []);

  return {
    onKennitalaChanged,
    onXsrf,
    audkenniAppState: state,
    invalidResource,
  };
}
